import { EManagementCommissionPdRole, EManagementCommissionStatus } from '../enums/management-commission.enum';
import { IManagementCommissionPdDescription } from '../interfaces/management-commission.interface';
import { IStatusDescription } from '../interfaces/status-description.interface';

export type ManagementCommissionStatusRecord = Record<
  EManagementCommissionStatus,
  IStatusDescription
>;

export type ManagementCommissionPdRecord = Record<EManagementCommissionPdRole, IManagementCommissionPdDescription>;
